var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticClass:"video-online",class:{ 'video-online--full': _vm.isFullScreen },attrs:{"src":("https://player.vimeo.com/video/" + _vm.vimeoId)}})}
var staticRenderFns = []

export { render, staticRenderFns }